import {AppDispatch} from '@lib/store';
import {useDispatch} from 'react-redux';

/**
 * @deprecated Prefer hooks from `@lib/store`
 */
export const useAppDispatch = () => useDispatch<AppDispatch>();
